import styled from 'styled-components';

export const ServicesListWrapper = styled.div`
  overflow-y: auto;
  height: 100%;
`;

export const ServicesList = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: auto;
  gap: 24px;

  @media (min-width: 320px) and (max-width: 500px) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media (min-width: 500px) and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 768px) and (max-width: 1280px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 1280px) and (max-width: 1680px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;
